export const sharedTest = {
  'user': {
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'first_name': 'رضا',
    'last_name': 'کیانی',
    'phone': '***',
    'birth_date': 768787200,
    'gender': 0
  },
  'user_label': {
    'created_at': 1630574818,
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5b',
    'patient_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'label': 'yellow'
  },
  'last_annotations': [
    {
      'created_at': 1630575818,
      'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
      'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5f',
      'description': 'این یک متن چند \n خطی است.'
    }
  ],
  'last_tests': [
    {
      'uuid': 'f39f5f4a-1aee-470a-8a39-97b16f326db5',
      'created_at': 1627639780,
      'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
      'type': 'bp',
      'name': 'test1',
      'app_version': 1,
      'product_type': 'EBM1',
      'tested_at': 1627639723,
      'description': 'SampleTest',
      'duration': 20000,
      'meta': null
    },
    {
      'uuid': 'f39f5f4a-1aee-470a-8a39-97b16f326db1',
      'created_at': 1627539780,
      'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
      'type': 'ecg',
      'name': 'test2',
      'app_version': 1,
      'product_type': 'EBM1',
      'tested_at': 1627539723,
      'description': 'SampleTest',
      'duration': 25000,
      'meta': {
        'subtype': '1-lead'
      }
    },
    {
      'uuid': 'f39f5f4a-1aee-470a-8a39-97b16f326db4',
      'created_at': 1631181293,
      'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
      'type': 'bp',
      'name': 'test1',
      'app_version': 1,
      'product_type': 'EBM1',
      'tested_at': 1636443277,
      'description': 'SampleTest',
      'duration': 20000,
      'meta': {
        'subtype': '1-lead'
      },
      'tags': ['salam', 'tag2']
    }
  ],
  'stats': {
    'bp': {
      'today': {
        'high': 0,
        'normal': 2,
        'low': 1
      },
      'last7': {
        'high': 3,
        'normal': 2,
        'low': 1
      },
      'last30': {
        'high': 5,
        'normal': 2,
        'low': 4
      },
      'last90': {
        'high': 10,
        'normal': 6,
        'low': 8
      }
    },
    'arithmies': {
      'today': {
        'tachycardia': 0,
        'bradycardia': 1,
        'afib': 0,
        'normal': 2
      },
      'last7': {
        'tachycardia': 2,
        'bradycardia': 1,
        'afib': 0,
        'normal': 3
      },
      'last30': {
        'tachycardia': 6,
        'bradycardia': 3,
        'afib': 5,
        'normal': 8
      },
      'last90': {
        'tachycardia': 20,
        'bradycardia': 5,
        'afib': 9,
        'normal': 40
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/shared-test.js